export const ordersQueryKey = ['orders'] as const;
export const orderMenuQueryKey = ['orderMenu'] as const;
